<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <loyalty-reward-table></loyalty-reward-table>
      </b-col><!--/.col-->
    </b-row><!--/.row-->
  </div>

</template>

<script>
  import loyaltyRewardTable from './LoyaltyRewardTable.vue'

  export default {
    name: 'loyaltyreward-table-view',
    components: {loyaltyRewardTable}
  }
</script>



// WEBPACK FOOTER //
// src/views/promotion/loyaltyreward/LoyaltyReward.vue